import React from 'react';
import { CitationData } from './types/chat.types';
import { formatPeriodForCitation } from '../../utils/formatPeriod';

interface ChatReferencesProps {
  messageId: string;
  citations?: Record<string, CitationData>;
  isExpanded: boolean;
  onToggle: (id: string) => void;
  onCitationClick?: (citation: CitationData) => void;
}

export const ChatReferences: React.FC<ChatReferencesProps> = ({ citations, onCitationClick }) => {
  if (!citations || Object.keys(citations).length === 0) {
    return null;
  }

  const citationEntries = Object.entries(citations);

  return (
    <div className="mt-3 pt-3 border-t border-nb-border/40">
      <p className="text-[10px] font-medium text-nb-text-muted uppercase tracking-wider mb-2">
        Fuentes
      </p>
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-none">
        {citationEntries.map(([number, citation]) => {
          const displayName = citation.company_name
            ? citation.company_name
            : citation.document_name;
          const subLabel =
            citation.company_name && citation.document_type
              ? `${citation.document_name}${formatPeriodForCitation(
                  citation.document_period,
                  citation.document_type
                )}`
              : citation.document_name;

          return (
            <button
              key={number}
              onClick={() => onCitationClick?.(citation)}
              className="flex-shrink-0 flex flex-col gap-0.5 px-3 py-2 rounded-lg border border-nb-border bg-nb-surface hover:bg-nb-surface-hover transition-colors text-left max-w-[200px] min-w-[140px]"
            >
              <div className="flex items-center gap-1.5">
                <span className="text-[9px] font-bold text-nb-accent bg-nb-accent/10 px-1.5 py-0.5 rounded">
                  {number}
                </span>
                {citation.document_type && (
                  <span className="text-[9px] text-nb-text-muted uppercase tracking-wide">
                    {citation.document_type}
                  </span>
                )}
              </div>
              <p className="text-[11px] font-medium text-nb-text leading-tight line-clamp-2">
                {displayName}
              </p>
              <p className="text-[10px] text-nb-text-muted truncate">
                {subLabel} · p.{citation.page}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChatReferences;
